import { render } from "./StackGame.vue?vue&type=template&id=4ecc6d1a&scoped=true"
import script from "./StackGame.vue?vue&type=script&lang=js"
export * from "./StackGame.vue?vue&type=script&lang=js"

import "./StackGame.vue?vue&type=style&index=0&id=4ecc6d1a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ecc6d1a"]])

export default __exports__